<template>
  <div ref="embedContainer" class="embed-container" :class="mainWrapperClass">
    <div ref="pdfHolder" class="pdf-holder">
    </div>
  </div>
</template>
<script>
export default {
  name: "docs-embed",
  props: {
    campaign: {
      type: String
    },
    docSource: {
      type: String,
      required: false,
      default: ''
    },
    mainWrapperClass: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      hasReplaced: false
    }
  },
  mounted() {
    // console.log('docSOURCE', this.docSource)
    this.fetchDoc(this.docSource)
  },
  methods: {
    fetchDoc(val) {
      let divContainer = this.$refs.embedContainer
      let pdfHolder = this.$refs.pdfHolder
      let url = val;
      if (url.startsWith("https://docs.google.com/document/d/")) {
        // create div and replace iframe
        let newDiv = document.createElement('div');
        newDiv.classList.add("embedded-doc"); // optional
        if (!this.hasReplaced) {
          divContainer.replaceChild(newDiv, pdfHolder);
          this.hasReplaced = true
        } else {
          let childToReplace;
          if (divContainer?.childNodes) {
            childToReplace = divContainer.childNodes[0]
          }
          divContainer.replaceChild(newDiv, childToReplace)
        }
        // CORS request
        var xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.onload = function () {
          // display response
          let tempXHR = xhr.responseText.replaceAll('<img', '<img referrerpolicy="no-referrer" ')
          newDiv.innerHTML = tempXHR;
        };
        xhr.send();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.embed-container {
  display: flex;
  width: 100% !important;
  justify-content: center;
  align-items: center;

  ::v-deep .embedded-doc {
    width: 80%;
    max-width: 80%;

    .doc-content {
      min-width: 100%;
      max-width: 100%;
      padding: 50px 20px;

      h3 {
        margin-left: auto;
        margin-right: auto;
      }
    }
  }
}

:deep(img) {
  max-width: 100vw !important;
}

::v-deep .c12 {
  font-size: 9.5pt !important;
}
::v-deep .c7 {
  font-size: 9.5pt !important;
}
::v-deep .c4 {
  font-size: 9.5pt !important;
}
::v-deep .c11 {
  font-size: 12pt !important;
}

</style>
